import { useMemo, useEffect, useState } from "react";
import { AddUpdateUserModal, BackButton, BadgeComponent, Breadcrumbs, ButtonComponent, DropDownComponent, IconButtonComponent, LoaderComponent, PaginationComponent } from "../../components";
import { PlusSvg, VerticalDotsSvg } from "../../assets/svgs";
import { useDispatch, useSelector } from "react-redux";
import { getAllUsers, getRolesListByInstitution, postAddUpdateUser } from "../../redux/slices/users-slice";
import { providerInstitutionConstant, statusConstant, statusOptions } from "../../constants/user-constants";
import { AuthPageContainer, AuthPageHead, ReactTableWrapper, ReactTableWrappers } from "../../styles/global-styles";
import { useLocation } from "react-router";
import { Menus } from "../../constants/menus-constant";
import ReactTable from "react-table";

const Users = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const { roles } = useSelector((state) => state.rolesListReducer);
    const { user } = useSelector((state) => state.loginUserReducer);
    const { loading, usersData, pagination } = useSelector((state) => state.usersReducer);

    const isProvider = (user?.institution?.id === providerInstitutionConstant?.id) && (user?.superAdmin);

    const MenuList = Menus({ user });

    const { label: PageLabel, icon: PageIcon } = MenuList?.flatMap(i => i?.subMenus)?.filter(i => i?.to === location?.pathname)[0];

    const initialPagination = {
        currentPage: 0,
        pageSize: 20,
    };
    const initialOrderBy = {
        sortColumn: "createdDateTime",
        isAsce: false,
    };
    const initialSearch = {
        userId: "",
        name: "",
        cnic: "",
        mobileNo: "",
        email: "",
        role: "",
        userStatus: "",
    };

    const initialForm = {
        userId: '',
        name: '',
        cnic: '',
        mobileNo: '',
        email: '',
        empNumber: '',
        department: '',
        designation: '',
        // remarks: '',
        is2FAEnable: false,
        otpType: '',
        userStatus: statusConstant?.activeValue,
        role: '',
        institution: isProvider ? '' : user?.institution?.value,
        createdBy: user?.userId,
        lastModifiedBy: null,
    };

    const initialStates = {
        data: [],
        pagination: initialPagination,
        orderBy: initialOrderBy,
        search: initialSearch,
        selected: null,
        isDropdownOpen: false,
        isModalOpen: false,
        isUpdate: false,
        isView: false,
        isFiltersOpen: false,
    };

    const [states, setStates] = useState(initialStates);

    const [form, setForm] = useState(initialForm);

    const defaultParams = { pagination: states.pagination, orderBy: states.orderBy, search: states.search };

    const getAllUsersData = (updatedParams) => {
        if (user && updatedParams) {
            dispatch(getAllUsers({ user, ...updatedParams }));
        }
    };

    // const handleReload = () => {
    //     getAllUsersData(defaultParams);
    // };

    const handlePagination = (e) => {
        const params = {
            ...defaultParams,
            pagination: {
                ...defaultParams.pagination,
                currentPage: e
            }
        };
        getAllUsersData(params);
    };

    const handleFormChange = (e) => {
        const { name, value, type, checked } = e.target

        if (name === 'institution') {
            setForm((old) => ({ ...old, [name]: ['checkbox', 'radio'].includes(type) ? checked : value, role: '' }));
        } else if (name === 'is2FAEnable') {
            setForm((old) => ({ ...old, [name]: ['checkbox', 'radio'].includes(type) ? checked : value, otpType: checked ? form.otpType : '' }));
        } else {
            setForm((old) => ({ ...old, [name]: ['checkbox', 'radio'].includes(type) ? checked : value }));
        }

        // if (name === 'role') {
        //     const institutionValue = roles.find((r) => r.value === value).institutionCode;
        //     setForm((old) => ({ ...old, [name]: ['checkbox', 'radio'].includes(type) ? checked : value, institution: institutionValue }));
        // }
    };

    // const handleChangeFilters = (e) => {
    //     const { name, value, type, checked } = e.target
    //     setStates((old) => ({
    //         ...old,
    //         search: ({
    //             ...old.search,
    //             [name]: ['checkbox', 'radio'].includes(type) ? checked : value
    //         })
    //     }));
    // };

    const handleSelectRow = (row) => {
        if (row === states.selected && states.isDropdownOpen) {
            setStates((old) => ({ ...old, isDropdownOpen: false, selected: null }));
        } else {
            setStates((old) => ({ ...old, isDropdownOpen: true, selected: row }));
        }
    };

    const handleCloseDropdown = () => {
        setStates((old) => ({ ...old, isDropdownOpen: false }));
    };

    // const handleToggleFilters = () => {
    //     setStates((old) => ({ ...old, search: initialSearch, isFiltersOpen: !states.isFiltersOpen }));
    // };

    const handleModalOpen = (e) => {
        if (['view', 'edit'].includes(e)) {
            setForm({
                ...states.selected,
                cnic: states.selected.cnic ? states.selected.cnic.replace(/^(\d{5})(\d{7})(\d{1})$/, '$1-$2-$3') : '',
                mobileNo: states.selected.mobileNo || '',
                is2FAEnable: states.selected?.is2FAEnable || false,
                otpType: states.selected?.otpType || '',
                userStatus: states.selected?.userStatus?.value,
                role: states.selected?.role?.value,
                institution: states?.selected?.institution?.value,
                empNumber: states?.selected?.empNumber?.split('-')[0],
                // forgotPassword: false,
            });

            if (e === 'view') {
                setStates((old) => ({ ...old, isView: true, isModalOpen: true }));
            } else if (e === 'edit') {
                setStates((old) => ({ ...old, isUpdate: true, isModalOpen: true }));
            }
        } else {
            setStates((old) => ({ ...old, isModalOpen: true }));
            setForm(initialForm);
        }
    };

    const handleModalClose = () => {
        setStates((old) => ({ ...old, isModalOpen: false, selected: null, isUpdate: false, isView: false }));
    };

    const handleFormSubmit = () => {
        const updatedForm = {
            ...form,
            cnic: form.cnic ? form.cnic.replace(/-/g, '') : null,
            mobileNo: form.mobileNo || null,
            empNumber: `${form.empNumber}-${form.institution}`,
            // remarks: form.remarks || null,
        }

        if (user && form) {
            dispatch(postAddUpdateUser({ user, body: updatedForm, update: states.isUpdate })).then((action) => {
                if (action?.payload?.status === 201 || action?.payload?.status === 200) {
                    handleModalClose();
                    getAllUsersData(defaultParams);
                }
            });
        }
    };

    // const handleFiltersSubmit = (e) => {
    //     e.preventDefault();
    //     const params = {
    //         ...defaultParams,
    //         search: states.search,
    //         pagination: initialPagination,
    //     };
    //     getAllUsersData(params);
    // };

    const handleFiltersSubmit = (e, customSearch = null) => {
        if (e) e.preventDefault();
        const searchToUse = customSearch || states.search;
        const params = {
            ...defaultParams,
            search: searchToUse,
            pagination: initialPagination,
        };
        getAllUsersData(params);
    };

    const handleTableFilterChange = (key, value, submit = false) => {
        setStates(old => {
            const updatedSearch = { ...old.search, [key]: value || '' };
            if (submit) {
                setTimeout(() => {
                    handleFiltersSubmit(null, updatedSearch);
                }, 0);
            }
            return { ...old, search: updatedSearch };
        });
    };

    const actions = [
        { label: 'View', action: () => handleModalOpen('view') },
        { label: 'Edit', action: () => handleModalOpen('edit') },
    ];

    useEffect(() => {
        getAllUsersData(defaultParams);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (usersData && Array.isArray(usersData)) {
            setStates((old) => ({ ...old, data: usersData, pagination: pagination }));
        }
    }, [usersData]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (user && form.institution !== '') {
            dispatch(getRolesListByInstitution({ user, institution: form.institution }));
        }
    }, [form.institution]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const handleClickOutside = (event) => {

            if (!event.target.closest('.action-dropdown')) {
                handleCloseDropdown();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // const searchFields = [
    //     {
    //         label: 'Username',
    //         type: 'text',
    //         placeholder: 'Search by Username',
    //         name: 'userId',
    //         value: states.search.userId,
    //     },
    //     {
    //         label: 'Name',
    //         type: 'text',
    //         placeholder: 'Search by name',
    //         name: 'name',
    //         value: states.search.name,
    //     },
    //     {
    //         label: 'CNIC',
    //         type: 'number',
    //         placeholder: 'Search by CNIC',
    //         name: 'cnic',
    //         value: states.search.cnic,
    //     },
    //     {
    //         label: 'Mobile Number',
    //         type: 'text',
    //         placeholder: 'Search by mobile number',
    //         name: 'mobileNo',
    //         value: states.search.mobileNo,
    //     },
    //     {
    //         label: 'Email',
    //         type: 'email',
    //         placeholder: 'Search by email',
    //         name: 'email',
    //         value: states.search.email,
    //     },
    //     {
    //         label: 'Role',
    //         type: 'select',
    //         options: roles,
    //         name: 'role',
    //         value: states.search.role,
    //     },
    //     {
    //         label: 'Status',
    //         type: 'select',
    //         options: statusOptions,
    //         name: 'userStatus',
    //         value: states.search.userStatus,
    //     },
    //     {
    //         type: 'action',
    //         actions: [
    //             { label: 'Cancel', icon: CrossSvg, type: 'button', outline: true, action: handleToggleFilters },
    //             { label: 'Search', icon: SearchSvg, type: 'submit', action: () => { } }
    //         ],
    //     }
    // ];

    // TABLE COLUMNS SETUP AS PER DATA
    // const columns = [
    //     { field: 'userId', headerName: 'User ID', width: 70 },
    //     { field: 'name', headerName: 'Name', width: 120 },
    //     { field: 'cnic', headerName: 'CNIC Number', width: 110, align: 'center' },
    //     { field: 'mobileNo', headerName: 'Mobile Number', type: 'number', width: 120, align: 'center' },
    //     { field: 'email', headerName: 'Email', type: 'number', width: 120 },
    //     {
    //         field: 'role', headerName: 'Role', width: 100,
    //         valueGetter: (row) => row?.role && row?.role?.label,
    //     },
    //     {
    //         field: 'institution', headerName: 'Institution', width: 100,
    //         valueGetter: (row) => row?.institution && row?.institution?.label,
    //     },
    //     {
    //         field: 'userStatus',
    //         headerName: 'Status',
    //         width: 80,
    //         align: 'center',
    //         valueGetter: (row) => {
    //             return (
    //                 <>
    //                     {
    //                         row?.userStatus &&
    //                         <BadgeComponent
    //                             label={row?.userStatus?.label}
    //                             type={{
    //                                 [statusConstant?.activeValue]: 'success',
    //                                 [statusConstant?.inactiveValue]: 'warning',
    //                                 [statusConstant?.lockedValue]: 'error'
    //                             }[row?.userStatus?.value] || 'default'}
    //                         />
    //                     }
    //                 </>
    //             )
    //         },
    //         sortBy: (row) => row?.userStatus?.label,
    //     },
    //     { field: 'createdDateTime', headerName: 'Created At', width: 170, align: 'center' },
    //     {
    //         field: 'action',
    //         headerName: 'Action',
    //         sortable: false,
    //         width: 100,
    //         align: 'right',
    //         sticky: 'right',
    //         valueGetter: (row) => {
    //             return (
    //                 <div className="action-dropdown" style={{ position: 'relative', float: 'right' }}>
    //                     <IconButtonComponent outline={!(states.isDropdownOpen && states.selected === row)} size='small' icon={VerticalDotsSvg} onClick={() => handleSelectRow(row)} />
    //                     <DropDownComponent isOpen={states.isDropdownOpen && states.selected === row} close={handleCloseDropdown} actions={actions} />
    //                 </div>
    //             )
    //         },
    //     },
    // ];

    const columns = useMemo(() => [
         {
            accessor: 'createdDateTime', Header: 'Created At', minWidth: 180,
            style: {
                textAlign: 'center'
            },
            sortable: false,
            filterable: false,
        },
        {
            accessor: 'userId', Header: 'User Name', 
            minWidth: 170,
            sortable: false,
            style: { textAlign: 'center' },
            Filter: ({ filter, onChange }) => (
                <input
                    type="text"
                    name="userId"
                    value={filter ? filter.value : ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onChange(value);
                        handleTableFilterChange('userId', value);
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) {
                            const value = e.target.value === '' ? undefined : e.target.value;
                            onChange(value);
                            handleTableFilterChange('userId', value, true);
                        }
                    }}
                    placeholder="Search by User Name"
                    style={{ width: '100%' }}
                />
            ),
            // filterable: false
        },
        { accessor: 'name', Header: 'Name', 
            minWidth: 165, 
            sortable: false, 
            style: { textAlign: 'center' },
            Filter: ({ filter, onChange }) => (
                <input
                    type="text"
                    name="name"
                    value={filter ? filter.value : ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onChange(value);
                        handleTableFilterChange('name', value);
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) {
                            const value = e.target.value === '' ? undefined : e.target.value;
                            onChange(value);
                            handleTableFilterChange('name', value, true);
                        }
                    }}
                    placeholder="Search by Name"
                    style={{ width: '100%' }}
                />
            ),
            // filterable: false 
        },
        { accessor: 'cnic', Header: 'National ID', 
            minWidth: 180, 
            sortable: false, 
            style: { textAlign: 'center' },
            Filter: ({ filter, onChange }) => (
                <input
                    type="text"
                    name="cnic"
                    value={filter ? filter.value : ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onChange(value);
                        handleTableFilterChange('cnic', value);
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) {
                            const value = e.target.value === '' ? undefined : e.target.value;
                            onChange(value);
                            handleTableFilterChange('cnic', value, true);
                        }
                    }}
                    placeholder="Search by National ID"
                    style={{ width: '100%' }}
                />
            ),
            // filterable: false 
        },
        { 
            accessor: 'mobileNo', Header: 'Mobile Number', 
            minWidth: 170, 
            sortable: false, 
            style: { textAlign: 'center' },
            Filter: ({ filter, onChange }) => (
                <input
                    type="text"
                    name="mobileNo"
                    value={filter ? filter.value : ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onChange(value);
                        handleTableFilterChange('mobileNo', value);
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) {
                            const value = e.target.value === '' ? undefined : e.target.value;
                            onChange(value);
                            handleTableFilterChange('mobileNo', value, true);
                        }
                    }}
                    placeholder="Search by Mobile"
                    style={{ width: '100%' }}
                    />
                ),
            // filterable: false 
        },
        {
            accessor: 'email',
            Header: 'Email',
            minWidth: 240,
            sortable: false,
            style: {
                textAlign: 'center'
            },
            Filter: ({ filter, onChange }) => (
                <input
                    type="email"
                    name="email"
                    value={filter ? filter.value : ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onChange(value);
                        handleTableFilterChange('email', value);
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) {
                            const value = e.target.value === '' ? undefined : e.target.value;
                            onChange(value);
                            handleTableFilterChange('email', value, true);
                        }
                    }}
                    placeholder="Search by Email"
                    style={{ width: '100%' }}
                />
            ),
            // filterable: false,
        },
        {
            accessor: 'role',
            Header: 'Role',
            minWidth: 140,
            style: {
                textAlign: 'center'
            },
            Cell: (row) => row?.original?.role && row?.original?.role?.label,
            sortable: false, 
            Filter: ({ filter, onChange }) => (
                <select
                    name="role"
                    value={filter ? filter.value : ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onChange(value);
                        handleTableFilterChange('role', value, true);
                    }}
                    style={{ width: '100%' }}
                >
                    <option value="">All</option>
                    {
                        roles.map((item, index) => (
                            <option key={index} value={item.value}>
                                {item.label}
                            </option>
                        ))
                    }
                </select>
            ),
            // filterable: false,
        },
        {
            accessor: 'institution',
            Header: 'Institution',
            minWidth: 140,
            style: {
                textAlign: 'center'
            },
            Cell: (row) => row?.original?.institution && row?.original?.institution?.label,
            sortable: false,
            filterable: false,
        },
        {
            accessor: 'userStatus',
            Header: 'Status',
            minWidth: 130,
            style: {
                textAlign: 'center',
            },
            Cell: (row) => {
                return (
                    <>
                        {
                            row?.original?.userStatus &&
                            <BadgeComponent
                                label={row?.original?.userStatus?.label}
                                type={{
                                    [statusConstant.activeValue]: 'success',
                                    [statusConstant.inactiveValue]: 'warning',
                                    [statusConstant.lockedValue]: 'error'
                                }[row?.original?.userStatus?.value] || 'default'}
                            />
                        }
                    </>
                )
            },
            sortable: false,
            Filter: ({ filter, onChange }) => (
                <select
                    name="userStatus"
                    value={filter ? filter.value : ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onChange(value);
                        handleTableFilterChange('userStatus', value, true);
                    }}
                    style={{ width: '100%' }}
                >
                    <option value="">All</option>
                    {
                        statusOptions.map((item, index) => (
                            <option key={index} value={item.value}>
                                {item.label}
                            </option>
                        ))
                    }
                </select>
            ),
            // filterable: false,
        },
       
        {
            accessor: 'action',
            Header: 'Action',
            minWidth: 100,
            // style: {
            //     height: 45, display: 'flex', justifyContent: 'flex-end', alignItems: 'center'
            // },
            Cell: (row) => {
                return (
                    <div className="action-dropdown" style={{ position: 'absolute' }}>
                        <IconButtonComponent outline={!(states.isDropdownOpen && states.selected === row?.original)} size='small' icon={VerticalDotsSvg} onClick={() => handleSelectRow(row?.original)} />
                        <DropDownComponent isOpen={states.isDropdownOpen && states.selected === row?.original} close={handleCloseDropdown} actions={actions} />
                    </div>
                )
            },
            sortable: false,
            filterable: false,
        },
    ], [ states.isDropdownOpen, states.selected, roles ]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <AuthPageContainer $heightfull>
            {/* BACK BUTTON */}
            <BackButton />
            {/* PAGE HEAD */}
            <AuthPageHead>
                <div className="left">
                     <PageIcon className="page-icon" />
                    <h1>Users</h1>
                    {/* <IconButtonComponent icon={ReloadSvg} outline size="small" disabled={loading} onClick={handleReload} className={loading && 'box-spin'} /> */}
                    <Breadcrumbs
                        items={[
                            { label: "Home", to: "/app/home" },
                            { label: PageLabel }
                        ]}
                        separator="›"
                        activeLastBreadcrumb={false}
                        size="small"
                        color={'var(--text-color-secondary)'}
                    />
                </div>

                <div className="right">
                    <ButtonComponent icon={PlusSvg} label="Add user" size="small" disabled={loading} onClick={handleModalOpen} />
                    {/* <IconButtonComponent icon={FilterSvg} outline onClick={handleToggleFilters} /> */}
                </div>
            </AuthPageHead>

            {/* FILTER */}
            {/* {
                searchFields && searchFields.length > 0 &&
                <FiltersComponent open={states.isFiltersOpen} searchFields={searchFields} handleChange={handleChangeFilters} handleSubmit={handleFiltersSubmit} />
            } */}

            {/* LOADING STATE */}
            {
                loading &&
                <LoaderComponent />
            }

            {/* EMPTY STATE */}
            {/* {
                !loading && states.data && states.data.length === 0 &&
                <EmptyTableComponent text='No data found!' />
            } */}

            {/* PAGE CONTENT */}
            {
                // !loading && states.data && states.data.length > 0 &&
                <>
                   <PaginationComponent
                        page={states?.pagination?.currentPage}
                        pages={states?.pagination?.totalPages || 1}
                        onPageChange={(e) => handlePagination(e)}
                        canPrevious={states?.pagination?.currentPage > 0}
                        canNext={states?.pagination?.currentPage < (states?.pagination?.totalPages - 1)}
                    />
                    {/* <div style={{ height: '16px' }} /> */}
                <ReactTableWrapper className="box-shadow custom-scrollbar">
                    {/* <TableComponent rows={states.data} columns={columns} icon={BadgeSvg} />
                                <PaginationComponent data={states.pagination} handleChange={(e) => handlePagination(e)} /> */}
                    <ReactTableWrappers>
                    <ReactTable
                        manual
                        loading={loading}
                        data={states?.data}
                        columns={columns}
                        page={states?.pagination?.currentPage || 0}
                        pageSize={states?.pagination?.pageSize || 20}
                        pages={states?.pagination?.totalPages || 1}
                        filterable={true}
                        showPagination={false}
                        showPageJump={true}
                        showPageSizeOptions={false}
                        showPaginationTop={true}
                        showPaginationBottom={false}
                        onPageChange={(e) => handlePagination(e)}
                        minRows={0}
                    // defaultFilterMethod={(filter, row, column) => {
                    //     return true;
                    // }}
                    // onFilteredChange={(filtered, column, value) => {
                    //     const searchCriteria = transformToObject(filtered);
                    //     setComponentState((prevState) => ({
                    //         ...prevState,
                    //         searchCriteria,
                    //         tableLoading: true,
                    //     }));

                    //     handleOnSearch(searchCriteria); // Trigger handle search
                    // }}
                    />
                    </ReactTableWrappers>
                </ReactTableWrapper>
                </>
            }

            {/* MODAL */}
            {
                states.isModalOpen &&
                <AddUpdateUserModal data={form} label={`${states.isUpdate ? 'Update' : states.isView ? 'View' : 'Add'} User`} viewOnly={states.isView} update={states.isUpdate} close={handleModalClose} handleFormChange={handleFormChange} handleFormSubmit={handleFormSubmit} slide/>
            }
        </AuthPageContainer>
    );
};

export default Users;